import ImportVM from './import-vm';
export default {
  init: function(node){
    var validationOptions = Kadenze.Knockout.DEFAULT_VALIDATION_OPTIONS;
    validationOptions.insertMessages = false;
    validationOptions.grouping = { deep: true, observable: true, live: true };
    ko.applyBindingsWithValidation(new ImportVM(), node, validationOptions);
  }
};